/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: 张印 hbzyin@163.com
 * @LastEditTime: 2023-08-18 15:47:22
 * @FilePath: /mall-fe/src/comps/HeaderMinCart.cscec3b.tsx
 * @Description: 商城门户购物车组件
 *
 */
import Color from 'color';
import useUrl from 'hooks/useUrl';
import CartIcon from 'icons/cart-icon';
import CartIconSolid from 'icons/cart-icon-solid';
import {
  CartContext,
  DeviceContext,
  RuntimeConfigurationContext,
  SiteContext,
} from 'libs/contexts';
import { resizeImage } from 'libs/urls';
import { formatPrice } from 'libs/utils';
import { useContext, useState } from 'react';

export default function HeaderMinCart({ children }: { children?: React.ReactNode }) {
  const site = useContext(SiteContext);
  const { buildImgSrc } = useContext(DeviceContext);
  const { quantity, skuList, totalAmount } = useContext(CartContext);
  const [visible, setVisible] = useState(false);
  const { getPublicUrl } = useUrl();
  const rtCtx = useContext(RuntimeConfigurationContext);
  const ossProvider = rtCtx.find((item) => item.key === 'ossProvider')?.value ?? 'obs';
  const publicBucketName = rtCtx.find((config) => config.key === 'public-app-name')?.value;
  const privateBucketName = rtCtx.find((config) => config.key === 'private-app-name')?.value;

  function handleVisible() {
    if (!skuList?.length) return;
    setVisible(true);
  }
  return (
    <div className="cart-box" onMouseEnter={handleVisible} onMouseLeave={() => setVisible(false)}>
      {children || (
        <a className="cart-info" href="/shopping_cart">
          <span className="cart-icon">{visible ? <CartIconSolid /> : <CartIcon />}</span>
          购物车
          {quantity > 0 && <span className="quantity">{quantity >= 99 ? '···' : quantity}</span>}
        </a>
      )}

      {visible && !!skuList?.length && (
        <>
          <div className="mark" />
          <div className="cart-list">
            <div className="cart-list-box">
              <div className="body">
                {skuList.map((item, index) => (
                  <div key={index} className="list-item">
                    <div className="item-goods-img">
                      <a href={`/product/detail?id=${item.mallSku.sysNo}`}>
                        <img
                          alt=""
                          src={`${resizeImage(
                            buildImgSrc(getPublicUrl(item.mallSku.mainImgUrl)),
                            60,
                            60,
                            {
                              ossProvider,
                              publicBucketName,
                              privateBucketName,
                            },
                          )}`}
                        />
                      </a>
                    </div>
                    <div className="item-goods-desc">
                      <a
                        href={`/product/detail?id=${item.mallSku.sysNo}`}
                        className="goods-title"
                        title={`${
                          item.mallSku.mallSpuName != null
                            ? item.mallSku.mallSpuName
                            : item.mallSku.thirdName
                        }`}
                      >
                        {item.mallSku.mallSpuName != null
                          ? item.mallSku.mallSpuName
                          : item.mallSku.thirdName}
                      </a>
                      <p className="goods-count">数量 {item.quantity}</p>
                    </div>
                    <div className="item-goods-info">
                      &yen;{' '}
                      {item.mallSku && item.mallSku.salesPrice
                        ? formatPrice(item.mallSku.salesPrice)
                        : '--.--'}
                    </div>
                  </div>
                ))}
              </div>
              <div className="foot">
                <div className="list-info">
                  <p className="info-content">
                    <span className="info-content-title">可购买商品</span>{' '}
                    <span>{quantity} 件</span>
                  </p>
                  <p className="info-content">
                    <span className="info-content-title">合计</span>{' '}
                    <span>&yen;{totalAmount?.toFixed(2)}</span>
                  </p>
                </div>
                <div className="list-box-btn">
                  <a href="/shopping_cart" title="查看购物车">
                    查看购物车
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <style jsx>{`
        .cart-box {
          width: 125px;
          height: 42px;
          background: #ffffff;
          border: 1px solid #e8e8e8;
          position: relative;
        }
        .cart-box:hover {
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        }
        .cart-box:hover .cart-info {
          color: ${site?.global?.platformMainColor};
        }
        .mark {
          width: 100%;
          height: 10px;
          background-color: #fff;
          position: absolute;
          left: 0;
          bottom: -5px;
          z-index: 100;
        }
        .cart-info {
          display: flex;
          width: 100%;
          height: 42px;
          font-size: 12px;
          color: #333333;
          white-space: nowrap;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
        .cart-icon {
          display: flex;
          align-items: center;
          margin-right: 8px;
        }
        .cart-icon :global(svg) :global(path) {
          fill: ${site?.global?.platformMainColor};
        }
        .quantity {
          display: inline-block;
          margin-left: 8px;
          min-width: 16px;
          height: 16px;
          line-height: 16px;
          font-size: 12px;
          padding: 0 3px;
          text-align: center;
          background: ${site?.global?.platformMainColor};
          border-radius: 4px;
          color: #fff;
        }
        .cart-list {
          width: 280px;
          height: auto;
          min-height: 70px;
          background-color: #fff;
          position: absolute;
          border: 1px solid #e8e8e8;
          top: 41px;
          right: -1px;
          z-index: 11;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
        }
        .cart-list-box {
          width: 100%;
          height: auto;
          padding-bottom: 73px;
          position: relative;
        }
        .body {
          width: 100%;
          height: auto;
          max-height: 260px;
          padding: 10px;
          overflow-y: auto;
        }
        .list-item {
          padding: 0 82px 0 58px;
          position: relative;
          margin-top: 10px;
          border: none;
        }
        .list-item:first-child {
          margin-top: 0px;
        }
        .list-item:hover .goods-title {
          color: ${site?.global?.platformMainColor};
        }
        .item-goods-img {
          width: 40px;
          height: 40px;
          overflow: hidden;
          position: absolute;
          top: 0;
          left: 10px;
        }
        .item-goods-img img {
          width: 40px;
          height: 40px;
        }
        .item-goods-desc {
          width: 100%;
          height: 40px;
          overflow: hidden;
          text-align: left;
          font-size: 0;
        }
        .goods-title {
          display: inline-block;
          vertical-align: top;
          max-width: 100%;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          white-space: nowrap;
          color: #333;
          font-size: 12px;
        }
        .goods-count {
          line-height: 17px;
          margin-top: 6px;
          font-size: 12px;
          text-align: left;
          margin-bottom: 0px;
          color: #999;
        }
        .item-goods-info {
          width: 72px;
          height: 40px;
          position: absolute;
          top: 0;
          right: 10px;
          font-size: 12px;
          line-height: 17px;
          text-align: right;
          color: #ea5604;
          font-weight: 600;
          white-space: nowrap;
        }
        .foot {
          width: 100%;
          position: absolute;
          left: 0;
          padding: 10px;
          height: 73px;
          bottom: 0;
          background-color: #fff;
          border-top: 1px solid #e8e8e8;
        }
        .list-info {
          width: 100%;
          height: auto;
          font-size: 0;
          white-space: nowrap;
        }
        .info-content {
          display: inline-block;
          vertical-align: top;
          width: 50%;
          line-height: 17px;
          margin-bottom: 0px;
          color: #ea5604;
          font-size: 12px;
          text-align: right;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .info-content:first-child {
          text-align: left;
        }
        .info-content span {
          font-size: 12px;
          font-weight: 600;
        }
        .info-content span.info-content-title {
          color: #333;
          font-weight: 400;
        }
        .list-box-btn {
          width: 100%;
          height: auto;
          margin-top: 8px;
          text-align: right;
        }
        .list-box-btn a {
          display: inline-block;
          vertical-align: top;
          background-color: ${site?.global?.platformMainColor};
          line-height: 28px;
          font-size: 12px;
          color: #fff;
          padding: 0 10px;
        }
        .list-box-btn a:hover {
          background-color: ${Color(site?.global?.platformMainColor).darken(0.1)};
        }
      `}</style>
    </div>
  );
}
